import uniqueId from 'lodash/uniqueId';
import { useEffect, useState } from 'react';

import { BreakpointsPubSub, browserBreakpoints } from 'utils/breakpoints';

const breakpointsPubSub = new BreakpointsPubSub(browserBreakpoints);
breakpointsPubSub.connect();

export function useBreakpoints() {
  const [browser, setBrowser] = useState(breakpointsPubSub.getBrowser());

  useEffect(() => {
    const key = uniqueId();
    const unsubscribe = breakpointsPubSub.subscribe(key, setBrowser);

    return () => unsubscribe();
  }, []);

  return { browser };
}
